module.exports = __webpack_public_path__ + "static/media/What-is-Meta.7f09a243.png";